import { useParams, useSearchParams } from "react-router-dom";
import React, { useState, useEffect } from "react";
import Busca from "../../components/busca/busca.jsx";
import Menu from "../../components/menu/menu.jsx";
import DataTable from "react-data-table-component";
import { confirmAlert } from "react-confirm-alert";
import 'react-confirm-alert/src/react-confirm-alert.css';
import ClienteCad from "../clientes-cad/clientes-cad.jsx";
import api from "../../services/api.js";
import "./clientes.css";

// custom styles para DataTable
// const customStyles = {
//   headCells: {
//     style: {
//       fontSize: '0.9rem',
//       fontWeight: 600,
//       paddingLeft: '12px',
//       paddingRight: '12px',
//     }
//   },
//   cells: {
//     style: {
//       paddingLeft: '12px',
//       paddingRight: '12px',
//       fontSize: '0.9rem'
//     }
//   }
// };

function Clientes(){
    // estado para dados vindos do endpoint
    const [searchParams    , setSearchParams]    = useSearchParams();
    const [dados, setDados] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    var CNPJCliente = searchParams.get("CNPJ");
    var usuario     = searchParams.get("usuario");
 
    // Busca os clientes e gerencia estado de loading/erro.
    useEffect(() => {
        let mounted = true; // evita setState após unmount
        const fetchClientes = async () => {
            setLoading(true);
            setError(null);
            try {
                console.log("Iniciando montagem de clientes");
                const resp = await api.get("/erp/clientesspartan?CNPJ=" + (CNPJCliente || "") + "&usuario=" + (usuario || ""));
                if (!mounted) return;
                setDados(resp.data || []);
                console.log("Clientes montados", resp.data);
            } catch (err) {
                if (!mounted) return;
                console.error('Não foi possível carregar os clientes', err);
                setError(err.message || "Erro ao carregar clientes");
                setDados([]); // limpa dados em caso de erro
            } finally {
                if (mounted) setLoading(false);
            }
        };

        fetchClientes();
        return () => { mounted = false; };
    }, [CNPJCliente, usuario]);

    // formata data/hora para duas linhas (data em cima, hora em baixo)
    const formatDateTime = (val) => {
        if (!val) return null;
        const d = new Date(val);
        if (isNaN(d)) return val;
        const date = d.toLocaleDateString('pt-BR');
        const time = d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
        return (
            <>
                <div className="date-line">{date}</div>
                <div className="time-line">{time}</div>
            </>
        );
    };

    const columns = [
        {
            name: 'Contrato',
            selector: row => row.contrato,
            sortable: true,
            minWidth: '100px',
            grow: 0
        },
        {
            name: 'Empresa',
            selector: row => row.cont_nome,
            sortable: true,
            minWidth: '120px',
            grow: 2,
            cell: row => <div className="cell-ellipsis" title={row.cont_nome}>{row.cont_nome}</div>
        },
        {
          name: 'Versão',
          selector: row => row.versao,
          sortable: true,
          minWidth: '100px',
          grow: 0
        },
        {
          name: 'Último acesso',
          selector: row => row.ultimo_acesso,
          sortable: true,
          minWidth: '145px',
          grow: 0,
          cell: row => <div className="cell-date" title={row.ultimo_acesso}>{formatDateTime(row.ultimo_acesso)}</div>
       },
       {
        name: 'Dados Contato',
        selector: row => row.cont_email,
        sortable: false,
        minWidth: '190px',
        grow: 0,
        cell: row => <div className="cell-multiline"><span className="small-text">{row.cont_email}</span><span className="small-text">{row.cont_fone}</span></div>
        },
        {
            name: 'Vl. Contrato',
            selector: row => row.cont_valor,
            sortable: true,
            right: true,
            minWidth: '120px',
            grow: 0,
            cell: row => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(row.cont_valor || 0)
         },
        {
            cell: (row) => <>
                <button onClick={() => Excluir(row.cont_id)} className="btn btn-primary ms-3"><i className="bi bi-file-earmark-text"></i></button>
            </>,
            minWidth: "110px",
            grow: 0,
            right: true,
            ignoreRowClick: true
       }
    ];

    const paginationOptions = {
        rowsPerPageText: 'Registros por página',
        rangeSeparatorText: 'de',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Todos',
      };

    function WhatsApp(fone){
        const url = "https://web.whatsapp.com/send?phone=55" + fone;
        window.open(url, "_blank", "noreferrer");
    }

    function Excluir(id){
        confirmAlert({
            title: 'Exclusão',
            message: 'Confirma exclusão do cliente?',
            buttons: [
              {
                label: 'Sim',
                onClick: () => alert('Excluir registro id: ' + id)
              },
              {
                label: 'Não',
                onClick: () => {}
              }
            ]
          });
    }

    function Novo(){    
        const event = new CustomEvent("openSidebar", { detail: {
            operacao: "new"
        }
        });

        window.dispatchEvent(event);
    }

    function Editar(id){    
        const event = new CustomEvent("openSidebar", { detail: {
            operacao: "edit"
        }
        });

        window.dispatchEvent(event);
    }

    return <>
    
    <ClienteCad />

    <div className="container-fluid">
        <div className="row flex-nowrap">
            <div className="col-auto col-md-3 col-xl-2 px-sm-2 px-0">
                <Menu page="clientes" />
            </div>

            <div className="col py-3 me-3">
                <div className="mb-5">
                    {/* <Busca texto="Busca por clientes" /> */}
                </div>
                
                <div className="bg-white p-4 rounded-4 border">

                    <div className="d-flex justify-content-between mb-3">
                        <div className="d-inline-flex">
                            <h2>Clientes</h2>

                            {/* <div className="form-control ms-4">
                                <select name="etapa" id="etapa">
                                    <option value="0">Etapa</option>
                                    <option value="Prospecção">Prospecção</option>
                                    <option value="Proposta">Proposta</option>
                                </select>
                            </div> */}
                        </div>                        

                        {/* <button onClick={Novo} className="btn btn-primary ms-4"><i className="bi bi-plus-lg me-2"></i>Novo Cliente</button> */}
                    </div>

                    {error && <div className="alert alert-danger">Erro ao carregar: {error}</div>}
                    {loading
                        ? <div>Carregando...</div>
                        : <div className="datatable-container">
                            <DataTable
                                columns={columns}
                                data={dados}
                                // pagination={true}
                                paginationComponentOptions={paginationOptions}
                                noDataComponent={"Nenhum registro encontrado"}
                                dense
                                responsive
                                // customStyles={customStyles}
                            />
                          </div>
                    }

                 </div>
                

                <div className="row">
                    
                    
                </div>
                
            </div>
        </div>
    </div>
</>
}

export default Clientes;